export const configKeyFromValue = (configValues,value) => {
    let result = '';
    for (let configValueKey in configValues) {
        if (configValues[configValueKey] == value) {
            result = configValueKey;
            break;
        }
    }
    return result;
}

const fieldValue = (item:Object,key:string) => {
    return (item != null && typeof item[key] !== 'undefined' ? item[key] : null);
}
export const getFieldValue = (item:Object,fieldName:string) => {
    let field = fieldName.split('.');
    let value = item;
    for (let i=0;i<field.length;i++) {
        value = fieldValue(value,field[i]);
    }
    return value;
}

export const deepCopy = (item:Object) => {
    return JSON.parse(JSON.stringify(item)) 
}

export const getLargestZIndex = () => {
    const allElements = document.getElementsByTagName('*');
    let maxZIndex = 0;
    Array.from(allElements).forEach(element => {
        if (element.classList.contains('loading-mask') == false && element.id != 'djDebug' && element.id != 'djDebugToolbar' && element.id != 'djDebugToolbarHandle' && element.classList.contains('djdt-panelContent') == false && element.classList.contains('djDebugLineChart') == false && element.classList.contains('djDebugLineChart') == false) {
            const zIndex = window.getComputedStyle(element).zIndex;
            // zIndexが数値であれば比較
            if (!isNaN(zIndex)) {
                maxZIndex = Math.max(maxZIndex, Number(zIndex));
            }
        }
    });
    return maxZIndex+1;
};

export const hankaku2Zenkaku = (str) => {
    return str.replace(/[A-Za-z0-9 ]/g, function(s) {
        if (s == ' ') {
            return '　';
        } else {
            return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
        }
    });
}
export const zenkaku2Hankaku = (str) => {
    return str.replace(/[Ａ-Ｚａ-ｚ０-９　]/g, function(s) {
        if (s == '　') {
            return ' ';
        } else {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        }
    });
}

export const zenkakukana2Hankakukana = (str) => {
    let kanaMap = {
        'ガ': 'ｶﾞ', 'ギ': 'ｷﾞ', 'グ': 'ｸﾞ', 'ゲ': 'ｹﾞ', 'ゴ': 'ｺﾞ',
        'ザ': 'ｻﾞ', 'ジ': 'ｼﾞ', 'ズ': 'ｽﾞ', 'ゼ': 'ｾﾞ', 'ゾ': 'ｿﾞ',
        'ダ': 'ﾀﾞ', 'ヂ': 'ﾁﾞ', 'ヅ': 'ﾂﾞ', 'デ': 'ﾃﾞ', 'ド': 'ﾄﾞ',
        'バ': 'ﾊﾞ', 'ビ': 'ﾋﾞ', 'ブ': 'ﾌﾞ', 'ベ': 'ﾍﾞ', 'ボ': 'ﾎﾞ',
        'パ': 'ﾊﾟ', 'ピ': 'ﾋﾟ', 'プ': 'ﾌﾟ', 'ペ': 'ﾍﾟ', 'ポ': 'ﾎﾟ',
        'ヴ': 'ｳﾞ', 'ヷ': 'ﾜﾞ', 'ヺ': 'ｦﾞ',
        'ア': 'ｱ', 'イ': 'ｲ', 'ウ': 'ｳ', 'エ': 'ｴ', 'オ': 'ｵ',
        'カ': 'ｶ', 'キ': 'ｷ', 'ク': 'ｸ', 'ケ': 'ｹ', 'コ': 'ｺ',
        'サ': 'ｻ', 'シ': 'ｼ', 'ス': 'ｽ', 'セ': 'ｾ', 'ソ': 'ｿ',
        'タ': 'ﾀ', 'チ': 'ﾁ', 'ツ': 'ﾂ', 'テ': 'ﾃ', 'ト': 'ﾄ',
        'ナ': 'ﾅ', 'ニ': 'ﾆ', 'ヌ': 'ﾇ', 'ネ': 'ﾈ', 'ノ': 'ﾉ',
        'ハ': 'ﾊ', 'ヒ': 'ﾋ', 'フ': 'ﾌ', 'ヘ': 'ﾍ', 'ホ': 'ﾎ',
        'マ': 'ﾏ', 'ミ': 'ﾐ', 'ム': 'ﾑ', 'メ': 'ﾒ', 'モ': 'ﾓ',
        'ヤ': 'ﾔ', 'ユ': 'ﾕ', 'ヨ': 'ﾖ',
        'ラ': 'ﾗ', 'リ': 'ﾘ', 'ル': 'ﾙ', 'レ': 'ﾚ', 'ロ': 'ﾛ',
        'ワ': 'ﾜ', 'ヲ': 'ｦ', 'ン': 'ﾝ',
        'ァ': 'ｧ', 'ィ': 'ｨ', 'ゥ': 'ｩ', 'ェ': 'ｪ', 'ォ': 'ｫ',
        'ッ': 'ｯ', 'ャ': 'ｬ', 'ュ': 'ｭ', 'ョ': 'ｮ',
        '。': '｡', '、': '､', 'ー': 'ｰ', '「': '｢', '」': '｣', '・': '･', '　': ' ', '１': '1', '２': '2', '３': '3', '４': '4', '５': '5', '６': '6', '７': '7', '８': '8', '９': '9', '０': '0'
    };

    let reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
    return str.replace(reg, function (match) {
        return kanaMap[match];
    }).replace(/ﾞ/g, '゛').replace(/ﾟ/g, '゜');
}

export const hankakukana2Zenkakukana = (str) => {
    let kanaMap = {
        'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
        'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
        'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
        'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
        'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
        'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
        'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
        'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
        'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
        'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
        'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
        'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
        'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
        'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
        'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
        'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
        'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
        'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
        '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・', ' ': '　', '1': '１', '2': '２', '3': '３', '4': '４', '5': '５', '6': '６', '7': '７', '8': '８', '9': '９', '0': '０'
    };

    let reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
    return str.replace(reg, function (match) {
        return kanaMap[match];
    }).replace(/ﾞ/g, '゛').replace(/ﾟ/g, '゜');
}

export const hira2kana = (str) => {
    return str.replace(/[\u3041-\u3096]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) + 0x60);
    });
}

export const postForm = (url,data) => {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url;
    form.target = '_blank'; // 新しいタブで開く
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'download_param';
    input.value = JSON.stringify(data);
    form.appendChild(input);
    const inputCsrf = document.createElement('input');
    inputCsrf.type = 'hidden';
    inputCsrf.name = 'csrfmiddlewaretoken';
    inputCsrf.value = <string>(document.getElementsByName('csrf_token').length == 0 ? '' : (!document.getElementsByName('csrf_token')[0].getAttribute('content') ? "" :  document.getElementsByName('csrf_token')[0].getAttribute('content')));
    form.appendChild(inputCsrf);
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
}

const hslToRgb = (h, s, l) => {
    let r, g, b;

    h /= 360;
    s /= 100;
    l /= 100;

    if (s === 0) {
        r = g = b = l; // グレースケール
    } else {
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = hueToRgb(p, q, h + 1/3);
        g = hueToRgb(p, q, h);
        b = hueToRgb(p, q, h - 1/3);
    }
    return { r: Math.round(r * 255), g: Math.round(g * 255), b: Math.round(b * 255) };
}

const hueToRgb = (p, q, t)  => {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1/6) return p + (q - p) * 6 * t;
    if (t < 1/2) return q;
    if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
    return p;
}

export const getDistinctColors = (numColors) => {
    const colors = [];
    const angle = 360 / numColors; // 色相の等間隔
    
    for (let i = 0; i < numColors; i++) {
        const hue = angle * i; // 色相を計算
        const rgb = hslToRgb(hue, 100, 50); // HSLからRGBに変換

        colors.push(`rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`);
    }
    return colors;
}
